import Vue from 'vue';
import VueTouch from 'vue-touch';
import gitpage from 'vue-gitpage'; // npm install vue-gitpage
import App from './App.vue';
import router from './router';
import store from './store';
import VueRouterBackButton from 'vue-router-back-button';
import VeeValidate from 'vee-validate';
import VuePageTransition from 'vue-page-transition';
import VueFriendlyIframe from 'vue-friendly-iframe';
//import AutoResponsive from 'autoresponsive-vue';
import Vuetify from 'vuetify';
import VueFullscreen from 'vue-fullscreen'
import device from 'vue-device-detector-js';
import axios from "axios";
import track from './mixins/track';
import 'vuetify/dist/vuetify.min.css';
const opts = {
  icons: {
    iconfont: 'md', // default - only for display purposes
  },
};

Vue.config.productionTip = false
Vue.use(Vuetify);
Vue.use(VueFullscreen);

import ECharts from 'vue-echarts';
import themeObj from './components/chart/theme/walden.project.json';
ECharts.registerTheme(themeObj.themeName, themeObj.theme);
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/radar';
import 'echarts/lib/chart/scatter';
import 'echarts/lib/chart/effectScatter';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/polar';
import 'echarts/lib/component/geo';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';
import 'echarts/lib/component/dataset';
import 'zrender/lib/svg/svg';

//import 'echarts-gl';



import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import moment from 'moment';
import VueClipboard from 'vue-clipboard2';
import GlobalEvents from 'vue-global-events'
import AppHeader from '@/components/Header';
import AppFooter from '@/components/Footer';


// import 'vuetify/dist/vuetify.min.css';
//import '@/assets/style/main.styl';
import 'material-design-icons-iconfont/dist/material-design-icons.css';



Vue.component('app-header', AppHeader);
Vue.component('app-footer', AppFooter);
Vue.component('echarts', ECharts);
Vue.component('GlobalEvents', GlobalEvents);
Vue.use(VueFriendlyIframe);
//Vue.use(AutoResponsive);

//Vue.use(VuePageTransition);
Vue.use(device);
Vue.use(VueRouterBackButton, { router });
Vue.use(VueTouch);
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(gitpage);
Vue.use(VeeValidate);

Vue.mixin(track);

Vue.filter('truncate', function (value, limit) {
  console.log(value);
  if (value instanceof Object)
    value = JSON.stringify(value);
  if (value.length > limit) {
    value = value.substring(0, limit - 3) + '...';
  }

  return value;
});

Vue.filter('formatTime', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD - HH:mm:ss A')
  }
});

Vue.config.productionTip = false;

Vue.prototype.getTime = function () {
  var d = new Date();
  var timestring =
                ("0" + d.getHours()).slice(-2)
                + ":" + ("0" + d.getMinutes()).slice(-2)
                + ":" + ("0" + d.getSeconds()).slice(-2)
                + ":" + ("0" + d.getMilliseconds()).slice(-3);
  return timestring;
};

Vue.prototype.makeId = function(length){
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

Vue.prototype.deviceInfo = async function(){
  let result = {};

  result.model = this.$device.model;
  result.brand = this.$device.brand;
  result.type = this.$device.type;
  result.os_name = this.$device.os_name;
  result.os_platform = this.$device.os_platform;
  result.os_version = this.$device.os_version;
  result.browser_name = this.$device.browser_name;
  result.browser_version = this.$device.browser_version;
  result.browser_engine = this.$device.browser_engine;
  result.browser_engine_version = this.$device.browser_engine_version;
  result.isMobile = this.$device.isMobile;
  result.isTablet = this.$device.isTablet;
  result.isDesktop = this.$device.isDesktop;

  let getIP = await axios.get('https://jsonip.com/');
  if(getIP.status == 200)
    result.IP = getIP.data.ip;

  return result;
}

Vue.prototype.currentDate = (iso) => {
  if(!iso)
    return moment(new Date()).format('YYYY-MM-DD')
  else
    return moment(new Date()).toISOString()
}

Vue.prototype.currentTime = () => {
  return moment(new Date()).format('YYYY-MM-DD hh:mm:ss');
}

Vue.prototype.isInLastMinutes = (start) => {
  try {
    if(!start)
      return false;
    let startTime = moment(start);
    let endTime = moment(new Date());
    let duration = moment.duration(endTime.diff(startTime)).asMinutes();
    let minutes = Math.floor(duration);
    if(minutes <= 0)
      return true;
    else
      return false;
  } catch (error) {
      return false;
  }
}

// Vue.prototype.$mms = webmms({
//   EiToken: getCookie("EiToken") || "",
//   SToken: getCookie("SToken") || ""
// });

Vue.prototype.isJson = function(str){
  try {
    JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
};

const DEFAULT_TITLE = 'jBoard';
router.afterEach((to, from) => {
    document.title = to.meta.title || DEFAULT_TITLE;
});

export const bus = new Vue();

new Vue({
  vuetify : new Vuetify(opts),
  router,
  store,
  render: h => h(App),
}).$mount('#app');
